export default __webpack_public_path__ + "static/media/mask7.9eacd331.jpeg";